import { createColumnHelper } from '@tanstack/react-table';

import { Scan, Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<Scan>();

export const scansColumns = [
  col.accessor((scan) => scan?._id || '-', {
    id: 'transactionId',
    header: 'Transaction ID',
    minSize: 200,
    size: 320,
  }),
  col.accessor((scan) => scan?.itemCount || '-', {
    id: 'itemCount',
    header: 'Items Count',
    minSize: 90,
    meta: { align: 'center' },
  }),
  col.accessor((scan) => scan?.caseCount || '-', {
    id: 'caseCount',
    header: 'Cases Count',
    minSize: 90,
    meta: { align: 'center' },
  }),
  col.accessor(
    (scan) =>
      `${scan?.scanPerformedBy?.fname || '-'} ${
        scan?.scanPerformedBy?.lname || ''
      }`,
    {
      id: 'scanPerformedBy',
      header: 'Scan Performed By',
      minSize: 150,
      meta: { align: 'center' },
    },
  ),
  col.accessor((scan) => convertUTCToLocal(scan?.performedAt, true), {
    id: 'performedAt',
    header: 'Scan Performed At',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((scan) => (scan?.status ? Status[scan?.status] : '-'), {
    id: 'status',
    header: 'Status',
    minSize: 110,
    meta: { align: 'center' },
  }),
  col.accessor(
    (scan) =>
      typeof scan?.isEPC === 'boolean'
        ? scan?.isEPC
          ? 'RFID'
          : 'Manual'
        : '-',
    {
      id: 'type',
      header: 'Type',
      minSize: 90,
      meta: { align: 'center' },
    },
  ),
  col.accessor((scan) => scan?.itemSku?.map((s) => s?.name).join(', ') || '-', {
    id: 'itemSku',
    header: 'Item SKU',
    minSize: 200,
    size: 320,
    meta: { align: 'center' },
  }),
  col.accessor(
    (scan) => scan?.site?.map((s: any) => s?.name).join(', ') || '-',
    {
      id: 'site',
      header: 'Site',
      minSize: 150,
      meta: { align: 'center' },
    },
  ),
];
